import { z } from 'zod';
import type { SchemaInput } from './schema-input.js';

export const KML_SOURCE_NAMESPACE = 'https://drawonamap.com/kml/1';
const digest = z.string().regex(/^[A-Za-z0-9_-]{43}$/);
export const kmlElementSchema = z.object({ document: z.string().max(2048), path: z.string().min(1).max(512).regex(/^\d+(?:\/\d+)*$/) }).strict();
export const kmlSourceSchema = kmlElementSchema.extend({
  source: digest,
  baseline: z.object({ geometry: digest, properties: digest, style: digest, image: digest, visible: z.boolean(), drawing: digest.optional() }).strict().optional(),
}).strict();
export type KmlSource = z.infer<typeof kmlSourceSchema>;
export const kmlArchiveSchema = z.object({
  id: digest, root: z.string().max(2048), elements: z.array(kmlElementSchema).max(300_000),
  images: z.array(kmlElementSchema.extend({ id: z.string().min(1).max(100), baseline: digest, pixels: digest })).max(20).optional(),
  imageConflict: z.boolean().optional(),
}).strict();

function parseKmlSource(value: SchemaInput): KmlSource | undefined {
  const parsed = kmlSourceSchema.safeParse(value);
  return parsed.success ? parsed.data : undefined;
}

export function restoreKmlSource(target: { kmlSource?: KmlSource }, value: SchemaInput): void {
  const source = parseKmlSource(value);
  if (source) target.kmlSource = source;
}
